import ChevronRight from "@assets/svg/ChevronRight";
import CustomText from "@components/CustomText";
import React from "react";
import { Image, StyleSheet, TouchableOpacity, View } from "react-native";
import { useNavigation } from "@react-navigation/native";
import IssueTags from "@components/IssueTags";
import ItemsToReturnStrip from "./ItemsToReturnStrip";
import ReturnLagaye from "./ReturnLagayeButton";

const ComboCard = ({ info, can_return = false }) => {
  const navigation = useNavigation();

  const seeComboReturn = () => {
    navigation.navigate("ComboReturn", {
      order_item_id: info?.order_item_id,
      item_number: info?.item_number,
      pop_back: 1,
    });
  };

  return (
    <View style={styles.mainContainer}>
      <View style={{ flexDirection: "row" }}>
        <View
          style={{
            padding: 9,
            borderWidth: 0.5,
            borderColor: "rgba(0, 0, 0, 0.10)",
            borderRadius: 12,
            height: 112,
            width: 112,
          }}
        >
          <Image
            style={{ height: 94, width: 94 }}
            source={{
              uri: info?.product_image,
            }}
          />
        </View>
        <View style={{ paddingVertical: 8, paddingLeft: 24, flex: 1 }}>
          <View
            style={{
              backgroundColor: "rgba(103, 61, 193, 1)",
              borderRadius: 40,
              paddingHorizontal: 8,
              paddingVertical: 3,
              alignSelf: "flex-start",
            }}
          >
            <CustomText
              variant="caption_1"
              style={{ color: "white", lineHeight: 18 }}
            >
              कॉम्बो
            </CustomText>
          </View>
          <CustomText
            variant="body_text_4"
            style={{ color: "rgba(0, 0, 0, 0.86)", marginTop: 8 }}
          >
            {info?.name}
          </CustomText>
          <View style={styles.issuesContainer}>
            <IssueTags current_state={info?.current_state || {}} />
          </View>

          {can_return ? (
            <View style={styles.issuesContainer}>
              <ReturnLagaye info={info} />
            </View>
          ) : (
            <TouchableOpacity
              testID="itemMark"
              onPress={() => navigation.navigate("ComboItems", { info })}
            >
              <View style={{ marginTop: 23, flexDirection: "row" }}>
                <CustomText
                  variant="body_text_4"
                  style={{
                    color: "rgba(0, 0, 0, 0.86)",
                    textDecorationLine: "underline",
                  }}
                >
                  {info?.btn_txt}
                </CustomText>
                <View style={{ height: 18, width: 18, marginLeft: 6 }}>
                  <ChevronRight pathFill="rgba(0, 0, 0, 1)" />
                </View>
              </View>
            </TouchableOpacity>
          )}
        </View>
      </View>
      {!can_return && info?.return_quantity ? (
        <TouchableOpacity
          testID="return_strip"
          onPress={() => seeComboReturn()}
          style={{ marginTop: 20 }}
        >
          <ItemsToReturnStrip
            return_quantity={info?.return_quantity}
            isClickable={true}
          />
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    borderColor: "rgba(157, 78, 221, 0.30)",
    borderWidth: 1,
    borderRadius: 20,
    padding: 8,
    marginHorizontal: 8,
    marginBottom: 12,
  },
  issuesContainer: {
    alignItems: "flex-start",
  },
});

export default ComboCard;
